// One place that turns a stored product filePath into a URL you can actually click.
//
// Two things kept breaking here:
//
//  1. Some pages hard-coded https://vixalgotrading.com/. That works in production and nowhere else
//     — running locally, the button sent you to the live site to fetch a file that only exists on
//     your machine, which looks exactly like a broken download.
//
//  2. The stored paths are not consistent. The products table holds all three of
//     `uploads/x.ex5`, `Uploads/x.ex5` and `Uploads\x.ex5` (a Windows separator that was saved
//     verbatim), while the static mount is `/Uploads`. A link built by naive concatenation works
//     for some products and 404s for others.
//
// So: always resolve against the configured API base, and normalise the path before appending it.
export function buildDownloadUrl(filePath) {
  if (!filePath) return '';
  const base = String(process.env.REACT_APP_API_URL || '').replace(/\/+$/, '');
  const normalised = String(filePath)
    .replace(/\\/g, '/')            // Windows separators that reached the database
    .replace(/^\/+/, '')            // no leading slash, the base supplies it
    .replace(/^uploads\//i, 'Uploads/');  // the static mount is /Uploads
  return `${base}/${normalised}`;
}

// The filename a browser should save it as.
export function downloadFileName(filePath) {
  return String(filePath || '').replace(/\\/g, '/').split('/').pop() || 'download';
}

export default buildDownloadUrl;
